import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
    Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import api from "@/lib/api";

export const FAQ = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/faqs")
            .then((r) => setItems(r.data || []))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, []);

    if (!loading && items.length === 0) return null;

    return (
        <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-white">
            <div className="max-w-4xl mx-auto px-6 lg:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-14"
                >
                    <p className="text-[#D4A537] uppercase tracking-[0.25em] text-xs font-semibold mb-4">Najczęstsze pytania</p>
                    <h2 className="font-serif text-4xl md:text-5xl text-[#092E22] leading-tight mb-4">
                        FAQ – informacje dla mieszkańców
                    </h2>
                    <div className="divider-gold w-24 mx-auto" />
                </motion.div>

                {loading ? (
                    <p className="text-gray-500 text-center" data-testid="faq-loading">Wczytywanie...</p>
                ) : (
                    <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
                        {items.map((f) => (
                            <AccordionItem
                                key={f.id}
                                value={`item-${f.id}`}
                                className="bg-[#FAF8F3] rounded-2xl border border-gray-100 px-6 data-[state=open]:bg-[#0D4F3C]/5 data-[state=open]:border-[#D4A537]/30 transition-colors"
                                data-testid={`faq-item-${f.id}`}
                            >
                                <AccordionTrigger className="font-serif text-lg text-[#092E22] hover:no-underline py-5 text-left">
                                    {f.question}
                                </AccordionTrigger>
                                <AccordionContent className="text-gray-600 leading-relaxed pb-5">
                                    {f.answer}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                )}
            </div>
        </section>
    );
};

export default FAQ;
